import { React, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import { IconList } from "./subcomponents/IconList";
import { motion } from "framer-motion";
import TimeLine from "./subcomponents/TimeLine";
import { BsChevronDoubleDown } from "react-icons/bs";
import { disableScroll, enableScroll } from "../helper funcs/ScrollBlock";

let hasPlayedHomeIntroThisSession = false;

export const Home = () => {
	const [shouldAnimate] = useState(() => {
		return !hasPlayedHomeIntroThisSession;
	});

	useEffect(() => {
		hasPlayedHomeIntroThisSession = true;
		window.scrollTo(0, 0);

		if (!shouldAnimate) {
			enableScroll();
			return;
		}

		disableScroll();

		const scrollTimer = setTimeout(() => {
			enableScroll();
		}, 7000);

		return () => {
			clearTimeout(scrollTimer);
			enableScroll();
		};
	}, [shouldAnimate]);

	return (
		<Container className="vih pb-5 shadow d-flex flex-column">
			<div className="overflow-hidden text-light text-center m-3 mt-5 mb-5">
				<motion.h1
					initial={shouldAnimate ? { opacity: 0 } : false}
					animate={shouldAnimate ? { opacity: 1 } : undefined}
					exit={{ opacity: 0 }}
					transition={shouldAnimate ? { duration: 0.5 } : undefined}
					className=""
				>
					Hi, I'm Ali Amin
				</motion.h1>
				<motion.hr
					id="hrLine"
					initial={shouldAnimate ? { scale: 0 } : false}
					animate={shouldAnimate ? { scale: 1 } : undefined}
					transition={
						shouldAnimate ? { duration: 1.5, delay: 2 } : undefined
					}
					className=""
				></motion.hr>
				<div className="">
					<motion.h1
						initial={shouldAnimate ? { opacity: 0, y: 200 } : false}
						animate={shouldAnimate ? { opacity: 1, y: 0 } : undefined}
						transition={
							shouldAnimate
								? { duration: 1.6, delay: 4, type: "spring" }
								: undefined
						}
					>
						Software Developer
					</motion.h1>
					<motion.h2
						initial={shouldAnimate ? { opacity: 0, y: 200 } : false}
						animate={shouldAnimate ? { opacity: 1, y: 0 } : undefined}
						transition={
							shouldAnimate
								? {
									duration: 1.8,
									delay: 4.2,
									type: "spring",
								}
								: undefined
						}
					>
						Computer Scientist
					</motion.h2>
					<motion.h5
						initial={shouldAnimate ? { opacity: 0, y: 200 } : false}
						animate={shouldAnimate ? { opacity: 1, y: 0 } : undefined}
						transition={
							shouldAnimate
								? {
									duration: 2,
									delay: 4.5,
									type: "spring",
								}
								: undefined
						}
					>
						Tech Enthusiast
					</motion.h5>
				</div>
			</div>
			<motion.div
				initial={shouldAnimate ? { rotate: 180 } : false}
				animate={
					shouldAnimate
						? {
							rotate: [180, 270, -360, 45, 0],
						}
						: undefined
				}
				layout
				transition={
					shouldAnimate
						? { duration: 4, ease: "easeInOut", delay: 1.5 }
						: undefined
				}
				className="m-auto"
			>
				<Image
					className="d-md-none logo"
					src={require("../images/Profile Picture.png")}
					roundedCircle
				/>
			</motion.div>

			<motion.div
				initial={shouldAnimate ? { opacity: 0 } : false}
				animate={shouldAnimate ? { opacity: 1 } : undefined}
				transition={shouldAnimate ? { duration: 1, delay: 6 } : undefined}
			>
				<IconList />
			</motion.div>
			<motion.div
				initial={shouldAnimate ? { opacity: 0 } : false}
				animate={shouldAnimate ? { opacity: 1 } : undefined}
				transition={shouldAnimate ? { duration: 1, delay: 6 } : undefined}
				className="mt-5 pt-5 w-100 d-flex justify-content-center "
			>
				<BsChevronDoubleDown className="text-center h1 text-blue view-animation" />
				<h3 className="me-3 ms-3 text-white">Career timeline</h3>
				<BsChevronDoubleDown className="text-center h1 text-blue view-animation" />
			</motion.div>
			<motion.div
				initial={shouldAnimate ? { opacity: 0 } : false}
				animate={shouldAnimate ? { opacity: 1 } : undefined}
				transition={shouldAnimate ? { duration: 1, delay: 7 } : undefined}
			>
				<TimeLine />
			</motion.div>
		</Container>
	);
};
